module.exports = __webpack_public_path__ + "static/media/buy.f8eb707a.png";